import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const envVariables = createEnv({
  server: {
    VERIFY_API_URL: z.url(),
    COVERAGE_API_KEY: z.string(),
  },
  runtimeEnv: process.env,
  emptyStringAsUndefined: true,
});
